import getTabId from 'commons/getTabId';

const getTabContentId = (itemLabel, componentName) =>
  `${getTabId(itemLabel, componentName)}-content`;

export default getTabContentId;
